import script from "./MockEnd.vue?vue&type=script&setup=true&lang=js"
export * from "./MockEnd.vue?vue&type=script&setup=true&lang=js"

import "./MockEnd.vue?vue&type=style&index=0&id=8973575c&lang=css"

const __exports__ = script;

export default __exports__